








import {Component, Prop, Vue} from 'vue-property-decorator';

@Component({
  name: "dialog-footer"
})
export default class DialogFooter extends Vue {
  @Prop({type: String, default: ''}) value !:any


}
